/**
 * What every view on a machine's page shares besides the Control API (`Workbench`): what the machine allows (its
 * opt-in scopes), whether the reader may change it, and the way to another view of the same page.
 */

import { createContext, useContext } from 'react';

import type { MachineScopes } from '../components/machineAllows.tsx';

export interface MachineContext {
  scopes: MachineScopes;
  kind: 'workbench' | 'node';
  /** The machine's name, for sentences ("JP's laptop is not reachable"). */
  name: string;
  /** The same at the start of a sentence ("The machine is not connected" before its record answers). */
  subject: string;
  /** Open another view of this page (`?view=`), with optional extra search parameters. */
  go: (view: string, extra?: Record<string, string>) => void;
}

export const MachineCtx = createContext<MachineContext | undefined>(undefined);

export function useMachine(): MachineContext {
  const m = useContext(MachineCtx);
  if (!m) throw new Error('A machine view renders inside the workbench page');
  return m;
}
